import { render, staticRenderFns } from "./NextSceneButton.vue?vue&type=template&id=4a1a9504&scoped=true&"
import script from "./NextSceneButton.vue?vue&type=script&lang=ts&"
export * from "./NextSceneButton.vue?vue&type=script&lang=ts&"
import style0 from "./NextSceneButton.vue?vue&type=style&index=0&id=4a1a9504&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1a9504",
  null
  
)

export default component.exports